import React, { useState } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Bio } from './components/Bio';
import { Curriculum } from './components/Curriculum';
import { HowItWorks } from './components/HowItWorks';
import { Footer } from './components/Footer';
export function App() {
  const [paid, setPaid] = useState(false);
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="2rknm2e6yncrv">
      <AnnouncementBar data-id="element-1" data-mp="2mlu9cnzhzpsr" />
      <main data-id="element-2" data-mp="2mmcc83go129n">
        <Hero paid={paid} onPay={() => setPaid(true)} data-id="element-3" data-mp="2mmvlkvs92ic2" />
        <Bio data-id="element-4" data-mp="2mjzp7bw1w1pq" />
        <Curriculum data-id="element-5" data-mp="31agoopp4khjz" />
        <HowItWorks paid={paid} onPay={() => setPaid(true)} data-id="element-6" data-mp="31ayv2f5i4c5m" />
      </main>
      <Footer data-id="element-7" data-mp="2wka1mua9h53u" />
    </div>;
}